import React from 'react';
import { Badge } from 'antd';
import styles from './COBadge.module.scss';
import { BadgeColors } from 'enums/COBadgeEnums';
import clsx from 'clsx';
export interface COBadgeProps {
  children: string | React.ReactNode;
  color?:
    | BadgeColors.BLUE
    | BadgeColors.PURPLE
    | BadgeColors.RED
    | BadgeColors.YELLOW
    | BadgeColors.GREY
    | BadgeColors.ORANGE
    | BadgeColors.DARKGREEN
    | BadgeColors.GREEN;
}

const COBadge: React.FC<COBadgeProps> = ({ children, color }: COBadgeProps) => {
  const badgeStyles = clsx({
    red: color === BadgeColors.RED,
    blue: color === BadgeColors.BLUE,
    purple: color === BadgeColors.PURPLE,
    yellow: color === BadgeColors.YELLOW,
    grey: color === BadgeColors.GREY,
    orange: color === BadgeColors.ORANGE,
    darkgreen: color === BadgeColors.DARKGREEN,
    green: color === BadgeColors.GREEN,
  });
  return <Badge className={badgeStyles}>{children}</Badge>;
};

export default COBadge;
